import {
  ADD_TRANSACTION_METHOD_BANK_NAME,
  ADD_TRANSACTION_METHOD_EWALLET_NAME,
  ADD_TRANSACTION_METHOD_HOME_NAME,
  ADD_TRANSACTION_METHOD_PICKUP_NAME,
  ADD_TRANSACTION_PAYMENT_METHOD_NAME,
  ADD_TRANSACTION_PAYOUT_METHOD_NAME,
  ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME,
  ADD_TRANSACTION_RECEIVER_GET_NAME,
  ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME,
  ADD_TRANSACTION_YOU_SEND_NAME,
  METHOD_BANK,
  METHOD_EWALLET,
  METHOD_HOME,
  METHOD_PAYTO,
  METHOD_PICKUP,
  OBJECT_DEFAULT,
  PAYMENT_CREADIT_CARD_NO,
  PAYMENT_CREADIT_CARD_TYPE,
  RESET_ADD_TRANSACTION_INFORMATION_STORE,
} from 'constants';
import useCalculatorRoundingStore from 'features/calculatorRounding/hooks/useCalculatorRoundingStore';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import Cookies from 'helpers/cookies';
import useQuery from 'hooks/useQuery';
import useStore from 'hooks/useStore';
import { isArray, isEmpty } from 'lodash';
import { stateStore } from 'store';
import {
  SET_ADD_TRANSACTION_CURRENT_STEP,
  SET_ADD_TRANSACTION_INFORMATION,
  SET_CURRENT_BUSINESS_RECEIVER,
  SET_CURRENT_RECEIVER,
  SET_TRANSACTION_DETAILS,
} from 'store/action';
import { MAKE_PAYMENT_KEY } from './useAddTransaction';

const useFormAddTransactionStore = () => {
  const { state, setState, dispatch } = useStore();
  const { setCalculatorRoundingResponse } = useCalculatorRoundingStore();
  const {
    currentReceiver,
    currentBusinessReceiver,
    addTransactionInformation,
    addTransactionCurrentStep,
    paytoAccountsAgreement,
  } = state;
  const {
    resetPaytoAccountInformation,
    resetPaytoMaxAmountEdited,
    setPaytoMaxAmountEdited,
    resetPaytoAccountAuthorising,
    resetPaytoAgreementEditing,
  } = usePaytoStore();

  const query = useQuery();
  const refNumber = query.get('refNumber');
  const isMakePayment = Cookies.get(MAKE_PAYMENT_KEY) || refNumber;

  const {
    receiverPayoutMethod,
    remittance,
    additionalInformation,
    paymentMethod,
  } = addTransactionInformation;

  const isPaytoBlocked =
    paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME] === METHOD_PAYTO &&
    isArray(paytoAccountsAgreement) &&
    paytoAccountsAgreement?.some(
      (accountAgreement) => accountAgreement?.blocked,
    );

  const setReceiverPayoutMethod = (receiverPayoutMethodData) =>
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        ...addTransactionInformation,
        receiverPayoutMethod: receiverPayoutMethodData,
      },
    });
  const setPayoutMethodItemByHOME = (itemId = 0) => {
    setReceiverPayoutMethod({
      ...receiverPayoutMethod,
      [ADD_TRANSACTION_METHOD_HOME_NAME]: {
        dmCode: METHOD_HOME,
        bank: null,
        pickupOffice: null,
        ewallet: null,
      },
      currentPayoutItemSelectedIndex: itemId,
    });
  };
  const setPayoutMethodItemByPICKUP = (itemData, itemId = 0) => {
    setReceiverPayoutMethod({
      ...receiverPayoutMethod,
      [ADD_TRANSACTION_METHOD_PICKUP_NAME]: {
        dmCode: METHOD_PICKUP,
        pickupOffice: itemData,
        bank: null,
        ewallet: null,
      },
      currentPayoutItemSelectedIndex: itemId,
    });
  };
  const setPayoutMethodItemByBANK = (itemData, itemId = 0) => {
    setReceiverPayoutMethod({
      ...receiverPayoutMethod,
      [ADD_TRANSACTION_METHOD_BANK_NAME]: {
        dmCode: METHOD_BANK,
        bank: itemData,
        pickupOffice: null,
        ewallet: null,
      },
      currentPayoutItemSelectedIndex: itemId,
    });
  };
  const setPayoutMethodItemByEWALLET = (itemData, itemId = 0) => {
    setReceiverPayoutMethod({
      ...receiverPayoutMethod,
      [ADD_TRANSACTION_METHOD_EWALLET_NAME]: {
        dmCode: METHOD_EWALLET,
        bank: null,
        pickupOffice: null,
        ewallet: itemData,
      },
      currentPayoutItemSelectedIndex: itemId,
    });
  };

  // Dispatch only the remittance slice, not a full `...addTransactionInformation`
  // snapshot. These setters are called from debounced/deferred calculator
  // callbacks that capture the render-time snapshot; on a currency change the
  // snapshot can be stale (previous currency) and land AFTER the discount
  // recovery commits the new currency's keys, reverting the sibling top-level
  // discount keys (discountFetchKey / discountDeriveKey / discountsActive) and
  // stalling revalidation. The reducer shallow-merges, so omitting the spread
  // preserves those current top-level values. Mirrors useCalculatorRounding's
  // fetchRate fix.
  const setRemittance = (remittanceData) =>
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        remittance: remittanceData,
      },
    });
  const setReceivingAmount = (receivingAmountData) => {
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        remittance: {
          ...remittance,
          ...receivingAmountData,
        },
      },
    });
  };

  const setReceiverPayoutMethodAndRemittance = (
    receiverPayoutMethodData,
    remittanceData,
  ) =>
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        ...addTransactionInformation,
        receiverPayoutMethod: receiverPayoutMethodData,
        remittance: remittanceData,
      },
    });

  const setAdditionalInformation = (additionalInformationData) =>
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        ...addTransactionInformation,
        additionalInformation: additionalInformationData,
      },
    });

  const setPaymentMethod = (paymentMethodData) => {
    const {
      discountsAvailable: discountsAvailableData,
      discountsInactive: discountsInactiveData,
      discountApplied: discountApplied,
    } = paymentMethodData || {};
    const {
      discountsAvailable: discountsAvailableStore,
      discountsInactive: discountsInactiveStore,
      discountApplied: discountAppliedStore,
    } = paymentMethod;
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        ...addTransactionInformation,
        paymentMethod: {
          ...paymentMethodData,
          discountsAvailable: !isEmpty(discountsAvailableData)
            ? discountsAvailableData
            : discountsAvailableStore,
          discountsInactive: !isEmpty(discountsInactiveData)
            ? discountsInactiveData
            : discountsInactiveStore,
          discountApplied: !isEmpty(discountApplied)
            ? discountApplied
            : discountAppliedStore,
        },
      },
    });
  };

  const setCurrentReceiver = (payload) =>
    setState({
      action: SET_CURRENT_RECEIVER,
      payload,
    });

  const setAddTransactionCurrentStep = (payload) =>
    setState({
      action: SET_ADD_TRANSACTION_CURRENT_STEP,
      payload,
    });

  const setCurrentBusinessReceiver = (payload) =>
    setState({
      action: SET_CURRENT_BUSINESS_RECEIVER,
      payload,
    });

  const setTransactionDetails = (transactionDetailsData = null) => {
    dispatch({
      type: SET_TRANSACTION_DETAILS,
      payload: !isEmpty(transactionDetailsData) ? transactionDetailsData : null,
    });
  };

  const setDiscountApplied = (payload) =>
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        ...addTransactionInformation,
        paymentMethod: {
          ...addTransactionInformation.paymentMethod,
          discountApplied: payload,
        },
      },
    });
  const resetDiscountApplied = () =>
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        ...addTransactionInformation,
        paymentMethod: {
          ...addTransactionInformation.paymentMethod,
          discountApplied: null,
        },
      },
    });

  const resetCurrentReceiver = () => {
    setCurrentReceiver(null);
  };
  const resetAddTransactionCurrentStep = () => {
    setAddTransactionCurrentStep(0);
  };
  const resetPayoutMethod = () => {
    const receiverPayoutMethodData = {
      ...receiverPayoutMethod,
      [ADD_TRANSACTION_PAYOUT_METHOD_NAME]: '',
      [ADD_TRANSACTION_METHOD_HOME_NAME]: null,
      [ADD_TRANSACTION_METHOD_PICKUP_NAME]: null,
      [ADD_TRANSACTION_METHOD_BANK_NAME]: null,
      [ADD_TRANSACTION_METHOD_EWALLET_NAME]: null,
      currentPayoutItemSelectedIndex: -1,
    };
    setReceiverPayoutMethod(receiverPayoutMethodData);
  };
  const resetPayoutMethodItem = () => {
    const receiverPayoutMethodData = {
      ...receiverPayoutMethod,
      [ADD_TRANSACTION_METHOD_HOME_NAME]: null,
      [ADD_TRANSACTION_METHOD_PICKUP_NAME]: null,
      [ADD_TRANSACTION_METHOD_BANK_NAME]: null,
      [ADD_TRANSACTION_METHOD_EWALLET_NAME]: null,
      currentPayoutItemSelectedIndex: -1,
    };
    setReceiverPayoutMethod(receiverPayoutMethodData);
  };
  const resetRemittances = () => {
    const remittanceData = {
      ...remittance,
      [ADD_TRANSACTION_YOU_SEND_NAME]: 0,
      [ADD_TRANSACTION_RECEIVER_GET_NAME]: 0,
      currentCurrencySelected: null,
      currentRateStore: null,
      [ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME]: 0,
      [ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME]: 0,
      isAddAnotherReceivingCurrency: false,
      currentCurrencySelectedAnother: null,
      currentRateAnotherStore: null,
      feeAmount: 0,
    };
    setRemittance(remittanceData);
  };
  const resetPayoutMethodItemAndRemittance = () => {
    const receiverPayoutMethodItemData = {
      ...receiverPayoutMethod,
      [ADD_TRANSACTION_METHOD_HOME_NAME]: null,
      [ADD_TRANSACTION_METHOD_PICKUP_NAME]: null,
      [ADD_TRANSACTION_METHOD_BANK_NAME]: null,
      [ADD_TRANSACTION_METHOD_EWALLET_NAME]: null,
      currentPayoutItemSelectedIndex: -1,
    };
    const remittanceData = {
      ...remittance,
      [ADD_TRANSACTION_YOU_SEND_NAME]: 0,
      [ADD_TRANSACTION_RECEIVER_GET_NAME]: 0,
      currentCurrencySelected: null,
      currentRateStore: null,
      [ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME]: 0,
      [ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME]: 0,
      isAddAnotherReceivingCurrency: false,
      currentCurrencySelectedAnother: null,
      currentRateAnotherStore: null,
      feeAmount: 0,
    };
    setReceiverPayoutMethodAndRemittance(
      receiverPayoutMethodItemData,
      remittanceData,
    );
  };
  const resetPayoutMethodAndRemittance = () => {
    const receiverPayoutMethodData = {
      ...receiverPayoutMethod,
      [ADD_TRANSACTION_PAYOUT_METHOD_NAME]: '',
      [ADD_TRANSACTION_METHOD_HOME_NAME]: null,
      [ADD_TRANSACTION_METHOD_PICKUP_NAME]: null,
      [ADD_TRANSACTION_METHOD_BANK_NAME]: null,
      [ADD_TRANSACTION_METHOD_EWALLET_NAME]: null,
      currentPayoutItemSelectedIndex: -1,
    };
    const remittanceData = {
      ...remittance,
      [ADD_TRANSACTION_YOU_SEND_NAME]: 0,
      [ADD_TRANSACTION_RECEIVER_GET_NAME]: 0,
      currentCurrencySelected: null,
      currentRateStore: null,
      [ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME]: 0,
      [ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME]: 0,
      isAddAnotherReceivingCurrency: false,
      currentCurrencySelectedAnother: null,
      currentRateAnotherStore: null,
      feeAmount: 0,
    };
    setReceiverPayoutMethodAndRemittance(
      receiverPayoutMethodData,
      remittanceData,
    );
  };
  const resetReceivingAmount1 = () => {
    const remittanceData = {
      ...remittance,
      [ADD_TRANSACTION_YOU_SEND_NAME]: 0,
      [ADD_TRANSACTION_RECEIVER_GET_NAME]: 0,
    };
    setRemittance(remittanceData);
  };
  const resetReceivingAmount2 = () => {
    const remittanceData = {
      ...remittance,
      [ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME]: 0,
      [ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME]: 0,
    };
    setRemittance(remittanceData);
  };
  const resetPaymentMethod = () => {
    setPaymentMethod({
      ...paymentMethod,
      [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: null,
      [PAYMENT_CREADIT_CARD_NO]: '',
      [PAYMENT_CREADIT_CARD_TYPE]: '',
      // discountsAvailable: [],
      // discountsInactive: [],
      // discountApplied:
      //   isMakePayment && !isEmpty(discountApplied) ? discountApplied : null,
      // discountDetails:
      //   isMakePayment && !isEmpty(discountDetails) ? discountDetails : null,
    });
  };
  const resetAddTransactionInformation = (resetOptions = OBJECT_DEFAULT) => {
    const { isResetTransactionDetails = true } = resetOptions || {};
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: RESET_ADD_TRANSACTION_INFORMATION_STORE,
    });
    if (isResetTransactionDetails) {
      setTransactionDetails();
    }
    resetPaytoAccountInformation();
    resetPaytoMaxAmountEdited();
    resetPaytoAccountAuthorising();
    resetPaytoAgreementEditing();
    setPaytoMaxAmountEdited();
  };
  const resetCurrentBusinessReceiver = () => {
    setState({
      action: SET_CURRENT_BUSINESS_RECEIVER,
      payload: null,
    });
  };

  const resetSendMoneyFlow = () => {
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: RESET_ADD_TRANSACTION_INFORMATION_STORE,
    });
    setState({
      action: SET_CURRENT_RECEIVER,
      payload: null,
    });
    setState({
      action: SET_ADD_TRANSACTION_CURRENT_STEP,
      payload: 0,
    });
  };

  // Reset Step 2 (remittance) to the same state as a first-time visit: clear
  // amounts, currency, rate, fee, all discount state and the quote-dedup cache,
  // while PRESERVING the Step-1 receiver/payout and staying on Step 2. Self-
  // guards on the live current step so it no-ops if closed from another step
  // (the reducer shallow-merges, so sibling slices like receiverPayoutMethod are
  // untouched). Used as the system-error modal's Close action on Step 2.
  const resetStep2ToFirstVisit = () => {
    if (stateStore?.addTransactionCurrentStep !== 1) return;

    const nextResetNonce =
      (stateStore?.addTransactionInformation?.step2ResetNonce || 0) + 1;
    setState({
      action: SET_ADD_TRANSACTION_INFORMATION,
      payload: {
        remittance: { ...RESET_ADD_TRANSACTION_INFORMATION_STORE.remittance },
        paymentMethod: {
          ...RESET_ADD_TRANSACTION_INFORMATION_STORE.paymentMethod,
        },
        discountsActive: [],
        discountFetchKey: '',
        discountDeriveKey: '',
        discountHardInvalidCodes: [],
        // Bump a nonce so AddTransactionPage remounts Remittance (Step 2),
        // re-initialising its local state to first-visit values. The store
        // reset alone cannot clear the on-screen amount/currency, which live in
        // the component's local state (hydrated from the store only on mount).
        step2ResetNonce: nextResetNonce,
      },
    });
    setCalculatorRoundingResponse();
  };

  return {
    ...state,
    dispatch,
    isMakePayment,
    isPaytoBlocked,
    receiverPayoutMethod,
    setReceiverPayoutMethod,
    setPayoutMethodItemByHOME,
    setPayoutMethodItemByPICKUP,
    setPayoutMethodItemByBANK,
    setPayoutMethodItemByEWALLET,
    remittance,
    setRemittance,
    setReceivingAmount,
    additionalInformation,
    setAdditionalInformation,
    paymentMethod,
    setPaymentMethod,
    currentReceiver,
    setCurrentReceiver,
    currentBusinessReceiver,
    setCurrentBusinessReceiver,
    addTransactionCurrentStep,
    setAddTransactionCurrentStep,
    resetCurrentReceiver,
    resetAddTransactionCurrentStep,
    resetPayoutMethod,
    resetPayoutMethodItem,
    resetRemittances,
    resetPayoutMethodAndRemittance,
    resetPayoutMethodItemAndRemittance,
    resetReceivingAmount1,
    resetReceivingAmount2,
    resetPaymentMethod,
    resetAddTransactionInformation,
    resetStep2ToFirstVisit,
    resetCurrentBusinessReceiver,
    setDiscountApplied,
    resetDiscountApplied,
    resetPaytoAccountInformation,
    setTransactionDetails,
    resetSendMoneyFlow,
  };
};

export default useFormAddTransactionStore;
